import React, { useRef, useState, useEffect, useCallback } from "react";
import { WithTooltip } from "../../StyledComponents/WithTooltip";
import { CategoryMeta } from "../CategoryMeta";
import { getCategoryIcon } from "../utils";

// styles
import { Wrapper, WidgetHead, WidgetTitle, WidgetContent } from "./styles";

function useIsClamped(text) {
  const ref = useRef(null);
  const [isClamped, setIsClamped] = useState(false);

  const checkClamped = useCallback(() => {
    const el = ref.current;
    if (el) {
      setIsClamped(el.scrollHeight > el.clientHeight);
    }
  }, []);

  useEffect(() => {
    checkClamped();
  }, [text, checkClamped]);

  return [ref, isClamped];
}

export default function CategoryWidget(props) {
  const [titleRef, isTitleClamped] = useIsClamped(props?.title);
  const [descriptionRef, isDescriptionClamped] = useIsClamped(props?.description);

  return (
    <Wrapper>
      <WidgetHead>{getCategoryIcon({ icon: props.icon, color: props.color || "#FF8C00", size: 24 })}</WidgetHead>
        <WithTooltip
          isNeeded={isTitleClamped}
          className="bottom-center"
          content={props?.title}
          size="250px"
        >
          <WidgetTitle ref={titleRef}>{props?.title}</WidgetTitle>
        </WithTooltip>
        <WithTooltip
          isNeeded={isDescriptionClamped}
          className="bottom-center"
          content={props?.description}
          size="250px"
        >
          <WidgetContent ref={descriptionRef}>{props?.description}</WidgetContent>
        </WithTooltip>
        <CategoryMeta categoryData={props} />
    </Wrapper>
  );
}
